import React from 'react';
import { Modal, Button, Typography } from 'antd';
import {
  CheckCircleOutlined,
  DeleteOutlined,
  EditOutlined,
  ExclamationCircleOutlined
} from '@ant-design/icons';

const { Title, Text } = Typography;

const ConfirmationModal = ({
  open,
  onCancel,
  onConfirm,
  type, // 'create', 'update', 'delete', 'status', 'success'
  title,
  description,
  confirmText,
  cancelText = 'Cancel',
  isSuccess = false,
  loading = false
}) => {

  const getIcon = () => {
    const style = { fontSize: '48px', marginBottom: '16px' };
    if (isSuccess) return <CheckCircleOutlined style={{ ...style, color: '#5FB92A' }} />; // Green check

    switch (type) {
      case 'delete': return <DeleteOutlined style={{ ...style, color: '#F04438' }} />; // Red delete
      case 'update':
      case 'status': return <EditOutlined style={{ ...style, color: '#00A3BF' }} />; // Blue edit
      case 'create': return <CheckCircleOutlined style={{ ...style, color: '#5FB92A' }} />; // Green check (mocking the look)
      default: return <ExclamationCircleOutlined style={{ ...style, color: '#F79009' }} />;
    }
  };

  const getConfirmButtonProps = () => {
    if (isSuccess) {
      return {
        style: { backgroundColor: '#5FB92A', width: '100%', height: '44px' },
        type: 'primary'
      };
    }

    switch (type) {
      case 'delete': return { danger: true, type: 'primary', style: { backgroundColor: '#D92D20', width: '150px', height: '44px' } };
      case 'create':
      case 'update':
      case 'status': return { style: { backgroundColor: '#5FB92A', width: '150px', height: '44px' }, type: 'primary' };
      default: return { type: 'primary', style: { width: '150px', height: '44px' } };
    }
  };

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={null}
      centered
      width={400}
      maskClosable={false}
      destroyOnClose={true}
      style={{
        maxHeight: 'calc(100vh - 40px)',
        paddingBottom: 0
      }}
      styles={{
        body: {
          padding: '24px',
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          fontFamily: "'Manrope', sans-serif"
        },
        mask: {
          backgroundColor: 'rgba(0, 0, 0, 0.45)'
        }
      }}
      closeIcon={null}
      wrapClassName="modal-fullscreen-wrapper"
    >
      <div style={{
        width: '80px',
        height: '80px',
        borderRadius: '50%',
        backgroundColor: isSuccess ? '#ECFDF3' : (type === 'delete' ? '#FEF3F2' : '#EFF8FF'),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '16px'
      }}>
        {getIcon()}
      </div>

      <Title level={4} style={{ marginBottom: '8px', fontWeight: 600 }}>{title}</Title>
      <Text type="secondary" style={{ marginBottom: '24px', display: 'block' }}>{description}</Text>

      {isSuccess ? (
        <Button {...getConfirmButtonProps()} onClick={onConfirm}>
          Done
        </Button>
      ) : (
        <div style={{ display: 'flex', gap: '12px', width: '100%', justifyContent: 'center' }}>
          <Button
            style={{ width: '150px', height: '44px', borderColor: '#D0D5DD', color: '#344054' }}
            onClick={onCancel}
          >
            {cancelText}
          </Button>
          <Button {...getConfirmButtonProps()} onClick={onConfirm} loading={loading}>
            {confirmText || 'Confirm'}
          </Button>
        </div>
      )}
    </Modal>
  );
};

export default ConfirmationModal;
